/*
 * B2 — Gift Card PDP própria (Case-Mate), dirigida por window.GiftHeroAPI (Gift Card Hero / Shop Circle).
 * Markup em snippets/gift-card-custom-pdp.liquid. v1: só E-Gift.
 *
 * Estratégia: UI é 100% nossa; o ESTADO e o addToCart passam pela API do app (assim o line item sai idêntico,
 * com __cardData, Recipient email, Send on, __shopify_send_gift_card_to_recipient, etc.).
 *
 * NOTA (verificar ao vivo): confirmamos no código minificado os métodos abaixo, mas NÃO os shapes exatos.
 * Por isso logamos getVariants()/getOptions() no console e aplicamos o valor por várias estratégias.
 */
(function () {
  'use strict';

  var root = document.getElementById('gcx');
  if (!root) return;

  var els = {
    amounts: document.getElementById('gcxAmounts'),
    customWrap: document.getElementById('gcxCustomWrap'),
    customAmount: document.getElementById('gcxCustomAmount'),
    price: document.getElementById('gcxPrice'),
    overlay: document.getElementById('gcxAmount'),
    message: document.getElementById('gcxMessage'),
    sendMode: document.getElementById('gcxSendMode'),
    recipient: document.getElementById('gcxRecipient'),
    to: document.getElementById('gcxTo'),
    email: document.getElementById('gcxEmail'),
    from: document.getElementById('gcxFrom'),
    date: document.getElementById('gcxDate'),
    qty: document.getElementById('gcxQty'),
    qtyInput: document.getElementById('gcxQty') ? document.getElementById('gcxQty').querySelector('input') : null,
    atc: document.getElementById('gcxAtc'),
    error: document.getElementById('gcxError'),
    cardImg: document.getElementById('gcxCardImg')
  };

  var state = {
    variantId: null,       // id numérico da variante (Liquid)
    priceCents: 0,
    isCustom: false,
    customValue: null,     // em dólares
    mode: 'gift',          // 'gift' | 'me'
    qty: 1
  };

  var api = null;

  // ---------- helpers ----------
  function log() { try { console.log.apply(console, ['[gcx]'].concat([].slice.call(arguments))); } catch (e) {} }
  function safe(fn) { try { return fn(); } catch (e) { log('erro:', e && e.message); return undefined; } }
  function has(name) { return api && typeof api[name] === 'function'; }

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function todayStr() {
    var d = new Date();
    var m = String(d.getMonth() + 1), day = String(d.getDate());
    if (m.length < 2) m = '0' + m;
    if (day.length < 2) day = '0' + day;
    return d.getFullYear() + '-' + m + '-' + day;
  }

  function showError(msg) {
    if (!els.error) return;
    if (msg) { els.error.textContent = msg; els.error.hidden = false; }
    else { els.error.textContent = ''; els.error.hidden = true; }
  }

  // ---------- render de preço / overlay ----------
  function renderAmount() {
    var label;
    if (state.isCustom) {
      var v = Number(state.customValue) || 0;
      label = '$' + v.toFixed(2);
    } else {
      label = money(state.priceCents);
    }
    if (els.price) els.price.textContent = label;
    if (els.overlay) els.overlay.textContent = label;
  }

  // ---------- aplica o valor na API (várias estratégias; ajustar após teste ao vivo) ----------
  function applyAmountToApi() {
    if (state.isCustom) {
      if (has('setCustomAmount')) safe(function () { api.setCustomAmount(Number(state.customValue) || 0); });
      return;
    }
    // valor fixo: tenta por variante e por valor (um dos dois é o que o app aceita)
    if (has('setVariant')) safe(function () { api.setVariant(state.variantId); });
    if (has('setCardValue')) safe(function () { api.setCardValue(state.priceCents / 100); });
  }

  // ---------- seleção de valor ----------
  function selectAmount(btn) {
    var all = els.amounts.querySelectorAll('.gcx__option');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
    btn.classList.add('is-active');

    state.isCustom = btn.getAttribute('data-custom') === 'true';
    state.variantId = btn.getAttribute('data-variant-id');
    state.priceCents = Number(btn.getAttribute('data-price')) || 0;

    if (els.customWrap) els.customWrap.hidden = !state.isCustom;
    if (state.isCustom && els.customAmount) {
      state.customValue = Number(els.customAmount.value) || 0;
      setTimeout(function () { els.customAmount.focus(); }, 0);
    }
    renderAmount();
    applyAmountToApi();
  }

  // ---------- modo de envio ----------
  function setMode(mode) {
    state.mode = mode;
    var btns = els.sendMode.querySelectorAll('.gcx__option');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('is-active', btns[i].getAttribute('data-mode') === mode);
    }
    // "send it to me": destinatário é o próprio comprador — escondemos os campos de recipient
    if (els.recipient) els.recipient.hidden = (mode === 'me');
  }

  // ---------- empurra os campos de texto p/ a API ----------
  function pushField(name) {
    switch (name) {
      case 'message': if (has('setMessage')) safe(function () { api.setMessage(els.message.value); }); break;
      case 'to':      if (has('setTo'))      safe(function () { api.setTo(els.to.value); }); break;
      case 'email':   if (has('setEmail'))   safe(function () { api.setEmail(els.email.value); }); break;
      case 'from':    if (has('setFrom'))    safe(function () { api.setFrom(els.from.value); }); break;
      case 'date':
        if (has('setDeliveryDate') && els.date.value) {
          safe(function () { api.setDeliveryDate(new Date(els.date.value + 'T12:00:00')); });
        }
        break;
    }
  }

  // ---------- quantidade ----------
  function setQty(n) {
    state.qty = Math.max(1, n || 1);
    if (els.qtyInput) els.qtyInput.value = state.qty;
  }

  // ---------- add to cart ----------
  function addToCart() {
    showError('');
    if (!api) { showError('Gift card builder is still loading, please try again.'); return; }

    // garante o estado atual na API antes de enviar
    applyAmountToApi();
    if (has('setMessage')) safe(function () { api.setMessage(els.message ? els.message.value : ''); });

    if (state.mode === 'gift') {
      // validação PRÓPRIA antes de tocar na API — se faltar algo, NEM seta data/destinatário
      // (senão fica pendurado e quebra o "send it to me" depois).
      var toV = els.to ? els.to.value.trim() : '';
      var emailV = els.email ? els.email.value.trim() : '';
      var fromV = els.from ? els.from.value.trim() : '';
      var missing = [];
      if (!toV) missing.push('recipient name');
      if (!emailV) missing.push('recipient email');
      if (!fromV) missing.push('your name');
      if (missing.length) { showError('Please fill in: ' + missing.join(', ') + '.'); return; }
      if (els.date && !els.date.value) els.date.value = todayStr();
      if (has('setTo'))    safe(function () { api.setTo(toV); });
      if (has('setEmail')) safe(function () { api.setEmail(emailV); });
      if (has('setFrom'))  safe(function () { api.setFrom(fromV); });
      if (has('setDeliveryDate') && els.date && els.date.value) {
        safe(function () { api.setDeliveryDate(new Date(els.date.value + 'T12:00:00')); });
      }
    } else {
      // "send it to me": comprador é o destinatário — limpa TODO estado de "gift" (inclui a data,
      // que setDeliveryDate não zera; mutamos o estado interno direto).
      safe(function () {
        if (api.cardData) {
          api.cardData.recipient = ''; api.cardData.to = ''; api.cardData.name = '';
          api.cardData.deliveryDate = null; delete api.cardData.deliveryDate;
        }
        if (api.properties) {
          ['Send on', '__shopify_offset', 'Recipient email', 'Recipient name',
           'Recipient email address', 'Your name', '__shopify_send_gift_card_to_recipient']
            .forEach(function (k) { try { delete api.properties[k]; } catch (e) {} });
        }
      });
    }
    log('addToCart — mode:', state.mode, 'variant:', state.variantId, 'custom:', state.isCustom);
    if (has('getProperties')) log('getProperties() antes do add:', safe(function () { return api.getProperties(); }));

    // valida (se disponível)
    if (has('validate')) {
      var res = safe(function () { return api.validate(); });
      if (res && res.valid === false) {
        var msg = '';
        if (res.errors) {
          if (Array.isArray(res.errors)) msg = res.errors.join(' ');
          else if (typeof res.errors === 'object') msg = Object.keys(res.errors).map(function (k) { return res.errors[k]; }).join(' ');
          else msg = String(res.errors);
        }
        showError(msg || 'Please complete the required fields.');
        return;
      }
    }

    if (!has('addToCart')) { showError('Unable to add to cart right now.'); return; }
    els.atc.setAttribute('disabled', 'disabled');
    var original = els.atc.textContent;
    els.atc.textContent = 'adding…';

    Promise.resolve(safe(function () { return api.addToCart(state.qty); }))
      .then(function (r) {
        log('addToCart result:', r);
        if (r && r.status && r.status >= 400) { throw new Error('cart error ' + r.status); }
        // abre o cart drawer do tema (mesmo mecanismo do ATC nativo)
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          var mc = document.querySelector('#mini-cart');
          if (mc) mc.setAttribute('open', '');
        }, 500);
        els.atc.removeAttribute('disabled');
        els.atc.textContent = original;
      })
      .catch(function (e) {
        log('addToCart falhou:', e);
        showError('Something went wrong adding to cart. Please try again.');
        els.atc.removeAttribute('disabled');
        els.atc.textContent = original;
      });
  }

  // ---------- bind de eventos ----------
  function bind() {
    if (els.amounts) {
      els.amounts.addEventListener('click', function (e) {
        var btn = e.target.closest('.gcx__option');
        if (btn) selectAmount(btn);
      });
    }
    if (els.customAmount) {
      els.customAmount.addEventListener('input', function () {
        state.customValue = Number(els.customAmount.value) || 0;
        renderAmount();
        if (has('setCustomAmount')) safe(function () { api.setCustomAmount(state.customValue); });
      });
    }
    /* inputs NÃO empurram pra API ao digitar — senão o validate passa a exigir campos no modo "pra mim".
       Os valores são lidos e enviados à API só no addToCart, conforme o modo. */

    if (els.sendMode) {
      els.sendMode.addEventListener('click', function (e) {
        var btn = e.target.closest('.gcx__option');
        if (btn) setMode(btn.getAttribute('data-mode'));
      });
    }
    if (els.qty) {
      els.qty.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-q]');
        if (b) setQty(state.qty + Number(b.getAttribute('data-q')));
      });
    }
    if (els.qtyInput) {
      els.qtyInput.addEventListener('change', function () { setQty(parseInt(els.qtyInput.value, 10)); });
    }
    if (els.atc) els.atc.addEventListener('click', addToCart);
  }

  // ---------- init ----------
  // acha a URL do DESIGN cadastrado no app.
  // Fonte correta = window.builderConfig.cards (o design selecionado, senão o primeiro).
  // getImages() devolve uma imagem diferente/placeholder (Page4...DO_NOT_DELETE), por isso NÃO usamos como principal.
  function pickImageUrl() {
    try {
      var bc = window.builderConfig;
      if (bc && Array.isArray(bc.cards) && bc.cards.length) {
        var sel = null;
        for (var i = 0; i < bc.cards.length; i++) { if (bc.cards[i] && bc.cards[i].selected) { sel = bc.cards[i]; break; } }
        if (!sel) sel = bc.cards[0];
        var u = sel && (sel.image || sel.img || sel.url || sel.src);
        if (u) { log('design do app (builderConfig.cards):', u); return u; }
      }
    } catch (e) {}
    // fallback: getImages()
    var data = has('getImages') ? safe(function () { return api.getImages(); }) : null;
    if (!data) return null;
    var pools = [data.cards, data.images, data.custom, data];
    for (var p = 0; p < pools.length; p++) {
      var arr = pools[p];
      if (!arr) continue;
      if (!Array.isArray(arr)) arr = [arr];
      for (var j = 0; j < arr.length; j++) {
        var it = arr[j];
        if (!it) continue;
        if (typeof it === 'string') return it;
        var v = it.url || it.src || it.image || it.imageUrl || it.href;
        if (v) return v;
      }
    }
    return null;
  }

  // usa o DESIGN cadastrado no app (builderConfig), a menos que a imagem esteja travada pela section
  function applyImage() {
    if (!els.cardImg) return;
    if (els.cardImg.getAttribute('data-locked') === 'true') return els.cardImg.src; // definida na section
    var src = pickImageUrl();
    if (!src) {
      var appImg = document.querySelector('.sc-gift-card__container img, .sc-gift-card img, #sc-giftcard-builder img');
      src = (appImg && (appImg.getAttribute('src') || appImg.currentSrc)) || null;
    }
    if (src && src.indexOf('//') === 0) src = 'https:' + src;
    if (src && els.cardImg.src !== src) { els.cardImg.src = src; log('imagem do cartão aplicada:', src); }
    return src;
  }

  function init() {
    api = window.GiftHeroAPI;
    log('GiftHeroAPI pronto. Inspecionando dados do app:');
    if (has('getVariants')) log('getVariants()', safe(function () { return api.getVariants(); }));
    if (has('getOptions')) log('getOptions()', safe(function () { return api.getOptions(); }));
    if (has('getImages')) log('getImages()', safe(function () { return api.getImages(); }));

    // default: primeiro valor não-custom
    var first = els.amounts ? els.amounts.querySelector('.gcx__option:not([data-custom])') : null;
    if (first) selectAmount(first);
    setMode('gift');
    setQty(1);

    // data de entrega: só preenche o campo visualmente (hoje). Só vai p/ a API no addToCart em modo "gift".
    if (els.date && !els.date.value) els.date.value = todayStr();

    // imagem do cartão: vem do app (getImages); tenta algumas vezes pois pode popular logo após o init
    applyImage();
    var imgTries = 0;
    var imgPoll = setInterval(function () {
      var got = applyImage();
      if (got || ++imgTries > 8) clearInterval(imgPoll);
    }, 500);
  }

  bind();

  // A API carrega assíncrona: espera o evento (ou usa a instância se já existir), com fallback por polling.
  if (window.GiftHeroAPI) {
    init();
  } else {
    var done = false;
    var onReady = function () { if (done) return; done = true; init(); };
    document.addEventListener('gift.hero:initalized', onReady); // (sic — grafia do app)
    var tries = 0;
    var poll = setInterval(function () {
      if (window.GiftHeroAPI) { clearInterval(poll); onReady(); }
      else if (++tries > 40) { clearInterval(poll); log('GiftHeroAPI não apareceu após 20s'); }
    }, 500);
  }
})();
